import React from 'react';
import { FaGithub, FaLinkedinIn, FaXTwitter, FaMedium } from "react-icons/fa6";

const RetroFooter = () => {
  const socialLinks = [
    {
      name:   'GITHUB',
      handle: '@WankioM',
      icon:   <FaGithub size={22} />,
      url:    'https://github.com/WankioM',
    },
    {
      name:   'LINKEDIN',
      handle: 'in/tracy-wankio-software-developer',
      icon:   <FaLinkedinIn size={20} />,
      url:    'https://www.linkedin.com/in/tracy-wankio-software-developer/',
    },
    {
      name:   'X',
      handle: '@TWankio',
      icon:   <FaXTwitter size={20} />,
      url:    'https://x.com/TWankio',
    },
    {
      name:   'MEDIUM',
      handle: '@tracywankio29',
      icon:   <FaMedium size={22} />,
      url:    'https://medium.com/@tracywankio29',
    },
  ];

  return (
    <footer className="relative border-t border-matrix-phosphor/30 bg-matrix-bg">
      {/* Scan lines */}
      <div className="absolute inset-0 overflow-hidden opacity-[0.08] pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute h-px w-full bg-matrix-phosphor"
            style={{ top: `${i * 5}%` }}
          />
        ))}
      </div>

      <div className="relative mx-auto max-w-7xl px-6 py-12">
        <div className="font-mono text-xs text-matrix-dim tracking-[0.3em] mb-8">
          [ 004 · CONNECT.SYS ]
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start gap-12">
          {/* Left: socials */}
          <div className="space-y-6 w-full md:w-auto">
            <h2 className="font-kelly text-4xl text-matrix-phosphor"
                style={{ textShadow: '0 0 12px rgba(0,255,102,0.5)' }}>
              &gt; LET'S_CONNECT
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl">
              {socialLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex items-center gap-3 bg-matrix-surface/60 border border-matrix-dim/40 hover:border-matrix-phosphor px-4 py-3 hover:shadow-phosphor-sm hover:bg-matrix-surface transition-all"
                >
                  <span className="text-matrix-dim group-hover:text-matrix-phosphor transition-colors flex-shrink-0">
                    {link.icon}
                  </span>
                  <div className="flex flex-col font-mono leading-tight min-w-0">
                    <span className="text-matrix-pale group-hover:text-matrix-phosphor uppercase tracking-[0.2em] text-xs transition-colors">
                      {link.name}
                    </span>
                    <span className="text-matrix-dim text-[10px] tracking-wider truncate">
                      {link.handle}
                    </span>
                  </div>
                  <span className="ml-auto text-matrix-dim group-hover:text-matrix-phosphor transition-colors text-xs">
                    ▸
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Right: signature block */}
          <div className="flex flex-col items-end space-y-3 font-mono text-right">
            <p className="text-matrix-dim text-[10px] uppercase tracking-[0.3em]">designed and built by</p>
            <p className="text-matrix-phosphor text-xl tracking-[0.15em]"
               style={{ textShadow: '0 0 10px rgba(0,255,102,0.45)' }}>
              TRACY_WANKIO
            </p>
            <div className="flex items-center space-x-2 mt-2">
              <span className="text-matrix-phosphor">[</span>
              <span className="text-matrix-pale text-xs uppercase tracking-widest">system_active</span>
              <span className="text-matrix-phosphor">]</span>
              <span className="h-2 w-2 rounded-full bg-matrix-phosphor shadow-phosphor-sm animate-pulse" />
            </div>
          </div>
        </div>

        {/* Bottom status row */}
        <div className="mt-10 pt-6 border-t border-matrix-dim/30 flex justify-end font-mono text-[11px] text-matrix-dim uppercase tracking-[0.2em]">
          <p>uptime: 9,999d</p>
        </div>
      </div>
    </footer>
  );
};

export default RetroFooter;
